import {ChangeDetectionStrategy, Component, effect, Injectable, input, signal, viewChild} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {GruppeId, SakstypeModell, SakstypeRessursClient} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {GruppeSakstypeRedigerListeKomponent} from "../gruppe-sakstype-rediger-liste/gruppe-sakstype-rediger-liste";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIcon} from "@angular/material/icon";
import {KortKomponent} from "web-ng2/delt/komponenter/kort/kort";
import {KortTittelKomponent} from "web-ng2/delt/komponenter/kort/kort-tittel/kort-tittel";
import {KortHandlingerKomponent} from "web-ng2/delt/komponenter/kort/kort-handlinger/kort-handlinger";

const debug = initDebugger('GruppeSakstyperKomponent');

@Component({
    selector: 'gruppe-sakstyper',
    templateUrl: 'gruppe-sakstyper.html',
    styleUrl: 'gruppe-sakstyper.scss',
    host: { 'data-testid': 'sakstyper' },
    imports: [
        GruppeSakstypeRedigerListeKomponent,
        MatButtonModule,
        TranslateModule,
        MatIcon,
        KortKomponent,
        KortTittelKomponent,
        KortHandlingerKomponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GruppeSakstyperKomponent {

    kortKomp = viewChild.required(KortKomponent);

    gruppeId = input.required<GruppeId>();

    sakstyper = signal<SakstypeModell[]>([]);
    visning = signal(true);

    constructor(private avhengigheter: GruppeSakstyperKomponentAvhengigheter) {
        effect(() => {
            debug('laster sakstyper for', this.gruppeId());
            this.avhengigheter.hentSakstyper(this.gruppeId())
                .then(st => this.sakstyper.set(st));
        });
    }

    visDetaljer() {
        this.kortKomp().setSomAktivOgSkrollTil();
    }

    skjulDetaljer() {
        this.kortKomp().setSomIkkeAktiv();
    }

    rediger() {
        this.visning.set(false);
    }

    redigeringFerdig(oppdaterteSakstyper: SakstypeModell[] | null) {
        if (oppdaterteSakstyper !== null)
            this.sakstyper.set(oppdaterteSakstyper);
        this.visning.set(true);
        this.kortKomp().skrollTil();
    }
}

@Injectable()
export class GruppeSakstyperKomponentAvhengigheter {

    constructor(private sakstypeRessurs: SakstypeRessursClient) {
    }

    hentSakstyper(gruppeId: GruppeId): Promise<SakstypeModell[]> {
        return this.sakstypeRessurs.finnAlle(gruppeId).somPromise();
    }
}
